export const FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_REQUEST =
  'FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_REQUEST';
export const FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_SUCCESS =
  'FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_SUCCESS';
export const FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_FAILED =
  'FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_FAILED';

export const FETCH_VEHICLE_GROUPS_AGGREGATES_REQUEST = 'FETCH_VEHICLE_GROUPS_AGGREGATES_REQUEST';
export const FETCH_VEHICLE_GROUPS_AGGREGATES_SUCCESS = 'FETCH_VEHICLE_GROUPS_AGGREGATES_SUCCESS';
export const FETCH_VEHICLE_GROUPS_AGGREGATES_FAILED = 'FETCH_VEHICLE_GROUPS_AGGREGATES_FAILED';

export const FETCH_VEHICLE_GROUPS_USAGE_REQUEST = 'FETCH_VEHICLE_GROUPS_USAGE_REQUEST';
export const FETCH_VEHICLE_GROUPS_USAGE_SUCCESS = 'FETCH_VEHICLE_GROUPS_USAGE_SUCCESS';
export const FETCH_VEHICLE_GROUPS_USAGE_FAILED = 'FETCH_VEHICLE_GROUPS_USAGE_FAILED';

export const FETCH_NOC_CALENDAR_REQUEST = 'FETCH_NOC_CALENDAR_REQUEST';
export const FETCH_NOC_CALENDAR_SUCCESS = 'FETCH_NOC_CALENDAR_SUCCESS';
export const FETCH_NOC_CALENDAR_FAILED = 'FETCH_NOC_CALENDAR_FAILED';

export const FETCH_VEHICLE_USAGES_REQUEST = 'FETCH_VEHICLE_USAGES_REQUEST';
export const FETCH_VEHICLE_USAGES_SUCCESS = 'FETCH_VEHICLE_USAGES_SUCCESS';
export const FETCH_VEHICLE_USAGES_FAILED = 'FETCH_VEHICLE_USAGES_FAILED';

export const FETCH_AGGREGATES_TOTALS_REQUEST = 'FETCH_AGGREGATES_TOTALS_REQUEST';
export const FETCH_AGGREGATES_TOTALS_SUCCESS = 'FETCH_AGGREGATES_TOTALS_SUCCESS';
export const FETCH_AGGREGATES_TOTALS_FAILED = 'FETCH_AGGREGATES_TOTALS_FAILED';

export const CHANGE_NOC_CALENDAR_DATES = 'CHANGE_NOC_CALENDAR_DATES';
export const CHANGE_NOC_CALENDAR_VISIBLE_TIMES = 'CHANGE_NOC_CALENDAR_VISIBLE_TIMES';

export const FETCH_QUALS_ACTIONS_REQUEST = 'FETCH_QUALS_ACTIONS_REQUEST';
export const FETCH_QUALS_ACTIONS_SUCCESS = 'FETCH_QUALS_ACTIONS_SUCCESS';
export const FETCH_QUALS_ACTIONS_FAILED = 'FETCH_QUALS_ACTIONS_FAILED';

export const FETCH_QUALS_ACTIONS_TOTALS_REQUEST = 'FETCH_QUALS_ACTIONS_TOTALS_REQUEST';
export const FETCH_QUALS_ACTIONS_TOTALS_SUCCESS = 'FETCH_QUALS_ACTIONS_TOTALS_SUCCESS';
export const FETCH_QUALS_ACTIONS_TOTALS_FAILED = 'FETCH_QUALS_ACTIONS_TOTALS_FAILED';

export const FETCH_RESERVATION_STATS_REQUEST = 'FETCH_RESERVATION_STATS_REQUEST';
export const FETCH_RESERVATION_STATS_SUCCESS = 'FETCH_RESERVATION_STATS_SUCCESS';
export const FETCH_RESERVATION_STATS_FAILED = 'FETCH_RESERVATION_STATS_FAILED';

export const FETCH_VEHICLE_STATS_REQUEST = 'FETCH_VEHICLE_STATS_REQUEST';
export const FETCH_VEHICLE_STATS_SUCCESS = 'FETCH_VEHICLE_STATS_SUCCESS';
export const FETCH_VEHICLE_STATS_FAILED = 'FETCH_VEHICLE_STATS_FAILED';
